import React from 'react';
import { Box, Heading, Text, Button, Code, VStack, Center, Icon } from '@chakra-ui/react';
import { FiAlertTriangle, FiRefreshCcw } from 'react-icons/fi';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReload = async () => {
        try {
            // 1. Unregister Service Workers
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                for (const registration of registrations) {
                    await registration.unregister();
                }
            }
            // 2. Clear Caches
            if ('caches' in window) {
                const keys = await caches.keys();
                await Promise.all(
                    keys.map(key => caches.delete(key))
                );
            }
        } catch (e) {
            console.error("Failed to clear cache:", e);
        } finally {
            // 3. Hard Reload
            window.location.reload(true);
        }
    };

    render() {
        if (this.state.hasError) {
            return (
                <Center h="100vh" bg="gray.50" p={4}>
                    <VStack spacing={6} maxW="600px" textAlign="center" bg="white" p={8} borderRadius="xl" shadow="xl">
                        <Icon as={FiAlertTriangle} boxSize={16} color="red.500" />
                        <Heading size="lg" color="gray.800">
                            哎呀！發生了一些問題
                        </Heading>
                        <Text color="gray.600">
                            應用程式遇到預期外的錯誤。這可能是由於網絡延遲或程式碼更新導致的緩存問題。
                        </Text>

                        <Box bg="red.50" p={4} borderRadius="md" w="100%" textAlign="left" overflowX="auto">
                            <Text fontWeight="bold" color="red.700" mb={2}>錯誤訊息:</Text>
                            <Code display="block" colorScheme="red" p={2}>
                                {this.state.error && this.state.error.toString()}
                            </Code>
                        </Box>

                        <Button
                            leftIcon={<FiRefreshCcw />}
                            colorScheme="blue"
                            size="lg"
                            onClick={this.handleReload}
                        >
                            重新整理頁面
                        </Button>

                        <Text fontSize="sm" color="gray.400">
                            如果重新整理無效，請截圖並聯繫系統管理員。
                        </Text>
                    </VStack>
                </Center>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
